module.exports = __webpack_public_path__ + "static/media/child_icon_boy.2b7ce541.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/child_icon_boy.svg
// module id = 210
// module chunks = 21